import styled from 'styled-components/macro';

export const PlayerCell = styled.div`
  color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  color: ${({ hovered }) => !hovered && ''};
  transition: color 0.2s;
`;

export const SquadContainer = styled.div`
  display: flex;

  table {
    padding: 10px;

    th {
      width: 10%;
      color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
      > div {
        display: block !important;
        text-align: center;
      }

      &:first-child {
        width: 70%;
        > div {
          display: block !important;
          text-align: left;
        }
      }
    }

    td {
      padding: 10px 8px 8px !important;
      font-family: ${({ theme }) => theme.primaryFontBold};
      font-size: ${({ theme }) => theme.paragraphSmall}px;
      font-weight: normal;
      text-transform: uppercase;
      text-align: center;
      span {
        width: 30px;
        font-family: ${({ theme }) => theme.primaryFontBold};
        font-weight: 200;
        display: inline-block;
      }

      &:first-child {
        font-family: ${({ theme }) => theme.primaryFontMedium};
        text-align: left;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    padding: 0;
    table {
      width: 100%;
      padding: 0;
      th,
      td {
        padding: 10px 20px 8px !important;
      }
    }
  }
`;
